import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Paper,
  Button,
  Typography,
  Modal,
  Input,
  Select,
  Icon,
} from '@safedns/skydns-ui-react-lib';

import ArrowButton from '../UI/go-back/GoBack';

import { getWordEnding } from '../../utils/getWordEnding';

import CollectionsConfigurate from './CollectionsConfigurate';
import SubmitBar from './SubmitBar';

import { notificationSuccess } from '../../store/notificationReducer';

import './Collections.scss';
import appStyles from '../app/App.module.scss';

import sprite from '../../icons/sprite.svg';

import {
  useGetUserQuery,
  useGetProfilesQuery,
  useGetCollectionsQuery,
  useCreateCollectionMutation,
} from '../../services/ADapi';

const CollectionsForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedUserIds = useSelector(
    (state) => state.tree.selectedUsersIdsForBackend
  );

  const {
    data: { user_id },
  } = useGetUserQuery();

  const { data: profilesList = [] } = useGetProfilesQuery(user_id);

  const { data: collections = [] } = useGetCollectionsQuery(user_id);
  const [createCollection] = useCreateCollectionMutation();

  const [isShowCollectionModal, setIsShowCollectionModal] = useState(false);

  const [name, setName] = useState('');
  const [nameIsBlur, setNameIsBlur] = useState(false);
  const [nameError, setNameError] = useState(
    'Collection name field is required'
  );
  const [policy, setPolicy] = useState('');
  const [initialPolicy, setInitialPolicy] = useState([]);
  const [isFormValid, setFormState] = useState(false);
  const [formIsSuccess, setFormIsSuccess] = useState(false);
  const [createCollectionData, setCreateCollectionData] = useState({
    plan_code: 'RESELLER',
    priority: collections.length + 1,
    profile: policy,
    domains: [],
    groups: [],
  });
  const [submitBarDialogState, setSubmitBarDialogState] = useState(false);

  useEffect(() => {
    nameError ? setFormState(false) : setFormState(true);
  }, [nameError]);

  useEffect(() => {
    // Find and set default policy
    let defaultProfileId = 0;

    if (profilesList.length > 0) {
      defaultProfileId = profilesList.filter((option) => option.is_default)[0]
        .id;
    }

    setInitialPolicy(defaultProfileId);
  }, [profilesList]);

  useEffect(() => {
    // Create initial data for a new collection
    setCreateCollectionData((d) => ({
      ...d,
      ad_users: selectedUserIds,
      profile: initialPolicy,
    }));
  }, [selectedUserIds, initialPolicy]);

  const nameHandler = (e) => {
    setName(e.target.value);

    if (!e.target.value) {
      setNameError('Name field is required');
    } else {
      setNameError('');
      setCreateCollectionData({
        ...createCollectionData,
        name: e.target.value,
      });
    }
  };

  const policyHandler = (e) => {
    setPolicy(e.target.value);
    setCreateCollectionData({
      ...createCollectionData,
      profile: +e.target.value,
    });
  };

  const blurHandler = (e) => {
    switch (e.target.name) {
      case 'name':
        setNameIsBlur(true);
        break;
      default:
        break;
    }
  };

  const sumbitForm = async (e) => {
    e.preventDefault();

    try {
      await createCollection({
        user_id,
        payload: createCollectionData,
      }).unwrap();
    } catch (error) {
      dispatch(
        notificationSuccess({
          isNotification: true,
          type: 'success',
          message: error.data,
        })
      );
    }
    setIsShowCollectionModal(true);
    setFormIsSuccess(!formIsSuccess);
    setFormState(false);
    setNameError('');
  };

  const onToggleCollectionModal = () => {
    navigate('/collections');

    setIsShowCollectionModal(false);
  };

  const successCircleCls = appStyles['circle'] + ' ' + appStyles['success'];

  return (
    <div className="collections-form-wrapper">
      <ArrowButton
        url="/collections"
        direction="left"
        title="Создание новой коллекции"
      />
      <Paper sx={{ position: 'relative' }}>
        <div className="collections-form-header">
          <div className="form-item">
            <Input
              id="collection"
              value={name}
              size="medium"
              placeholder="Название коллекции"
              onChange={nameHandler}
              onBlur={blurHandler}
            />
            {nameIsBlur && nameError && (
              <span className="validate-error">{nameError}</span>
            )}
          </div>
          <div className="form-item">
            <Select value={policy} onChange={policyHandler}>
              {profilesList.map((option) => (
                <option key={`key-${option.id}`} value={option.id}>
                  {option.name}
                </option>
              ))}
            </Select>
          </div>
        </div>

        <CollectionsConfigurate collectionName={name} />

        <SubmitBar
          isFormValid={isFormValid}
          onSubmit={sumbitForm}
          buttonText="Создать коллекцию"
          dialogState={submitBarDialogState}
          dialogAction={setSubmitBarDialogState}
        />
      </Paper>
      {isShowCollectionModal ? (
        <Modal
          title="Коллекция создана"
          isOpen={isShowCollectionModal}
          onClose={onToggleCollectionModal}
          sx={{ maxWidth: 460 }}
        >
          <div className="collections-success-modal">
            <div className={successCircleCls}>
              <Icon
                id="collection-created"
                sprite={sprite}
                width={28}
                height={28}
                color="white"
              />
            </div>
            <ul className="success-modal-list">
              <Typography variant="body1" component="li">
                {name}
              </Typography>
              <Typography variant="body1" component="li">
                {policy || initialPolicy}
              </Typography>
              <Typography variant="body1" component="li">
                {getWordEnding(selectedUserIds.length)}
              </Typography>
            </ul>
            <Button variant="primary" onClick={onToggleCollectionModal}>
              Закрыть
            </Button>
          </div>
        </Modal>
      ) : null}
    </div>
  );
};

export default CollectionsForm;
